export default "__VITE_ASSET__ae8a3f79__"